import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "shards-react";
import Layout from "shared/container/Layout";
import styled from "styled-components";
import MenuBar from "shared/components/MenuBar/MenuBar";
import ReactPaginate from "react-paginate";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import contentimgset from "shared/assets/img/contentimgset.png";
import {
  ModalCreateFooterSetting,
  ModalDeleteFooterSetting,
} from "views/AdminFooterSetting/components";
import { ToastContainer, toast } from "react-toastify";

const axios = require("axios").default;

const StyledTable = styled.table`
  width: 100%;
  thead {
    height: 60px;
  }
  tbody tr td {
    border-bottom: 1px solid #e5e5e5;
    padding: 20px 0;
  }
`;
const StyledMedia = styled.div`
  display: flex;
  align-items: center;
  color: #000;
  .media-icon {
    padding: 20px;
    svg {
      height: 45px;
    }
  }
  .media-body-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .media-body-subtitle {
    color: #818181;
  }
  .media-body {
    line-height: 2.5rem;
  }
`;

const AdminFooterSetting = (props) => {
  const { token } = useToken();
  const [footersettingListData, setFootersettingListData] = useState(null);
  const [
    openModalCreateIFooterSetting,
    setOpenModalCreateIFooterSetting,
  ] = useState(false);
  const [
    openModalDeleteFooterSetting,
    setOpenModalDeleteFooterSetting,
  ] = useState(false);
  const [footerstingEditData, setFooterstingEditData] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          footerSettingId: "",
        },
        show: 30,
        page: pageNumber,
        orderBy: "footerSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/footersettinglist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          //   setBannerSettingData(response.data);
          setFootersettingListData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [openModalCreateIFooterSetting, openModalDeleteFooterSetting]);

  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };
  return (
    <>
      <Layout>
        <ToastContainer />
        <Container>
          <ToastContainer />
          <Row>
            <Col md="6">
              <h6 className="bold">จัดการหน่วยงานเกี่ยวข้อง</h6>
            </Col>
            <Col md="6" className="text-right">
              <Button
                className="btn-white"
                onClick={() => {
                  setOpenModalCreateIFooterSetting(true);
                  setFooterstingEditData(null);
                }}
              >
                + เพิ่มหน่วยงานเกี่ยวข้อง
              </Button>
            </Col>
            <hr />
            {footersettingListData != null &&
              footersettingListData.data.length < 4 && (
                <Col md="6" className="text-right">
                  <Button
                    className="btn-white"
                    onClick={() => {
                      setOpenModalCreateIFooterSetting(true);
                      setFooterstingEditData(null);
                    }}
                  >
                    + เพิ่มหน่วยงานเกี่ยวข้อง
                  </Button>
                </Col>
              )}
          </Row>
          <hr />
          <Row>
            <Col md="12">
              <StyledTable>
                <thead>
                  <tr>
                    <th style={{ width: "95px" }}>ลำดับหัวข้อ</th>
                    <th>ชื่อหน่วยงานเกี่ยวข้อง</th>
                    <th style={{ width: "150px" }}>เครื่องมือ</th>
                  </tr>
                </thead>
                <tbody>
                  {footersettingListData != null &&
                  footersettingListData.data.length > 0 ? (
                    footersettingListData.data.map((item, key) => (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>
                          <StyledMedia className="media">
                            <img
                              style={{ width: "100px" }}
                              className="mr-3"
                              src={
                                item.footerSettingPic
                                  ? `${baseUrl}/${item.footerSettingPic}`
                                  : contentimgset
                              }
                              alt="content"
                            />
                            <div className="media-body">
                              <div>
                                <strong>ภาษาไทย: </strong>
                                {item.footerSettingName
                                  ? item.footerSettingName
                                  : "-"}
                              </div>
                              <div>
                                <strong>English: </strong>
                                {item.footerSettingNameEN
                                  ? item.footerSettingNameEN
                                  : "-"}
                              </div>
                              <div>
                                <strong>Link: </strong>
                                <a
                                  href="javascript:;"
                                  onClick={() =>
                                    window.open(
                                      `${
                                        item.footerSettingLink
                                          ? item.footerSettingLink
                                          : "#"
                                      }`
                                    )
                                  }
                                >
                                  {item.footerSettingLink
                                    ? item.footerSettingLink
                                    : "-"}
                                </a>
                              </div>
                            </div>
                          </StyledMedia>
                        </td>
                        <td>
                          <Button
                            className="btn-white"
                            style={{ marginRight: "15px" }}
                            onClick={() => {
                              setOpenModalCreateIFooterSetting(true);
                              setFooterstingEditData(item);
                            }}
                          >
                            แก้ไขข้อมูล
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">ไม่มีข้อมูลตัวชี้วัด</td>
                    </tr>
                  )}
                </tbody>
              </StyledTable>
            </Col>
            <Col md="12" style={{ textAlign: "right" }}>
              {footersettingListData != null && (
                <ReactPaginate
                  pageCount={totalPage}
                  forcePage={pageNumber - 1}
                  containerClassName="pagination"
                  nextLabel=">"
                  previousLabel="<"
                  onPageChange={({ selected }) => {
                    nextPage(selected, totalPage);
                  }}
                />
              )}
            </Col>
          </Row>
        </Container>
      </Layout>

      {openModalCreateIFooterSetting && (
        <ModalCreateFooterSetting
          open={openModalCreateIFooterSetting}
          toggle={() => setOpenModalCreateIFooterSetting(false)}
          openDelete={() => setOpenModalDeleteFooterSetting(true)}
          data={footerstingEditData}
          selectList={footersettingListData ? footersettingListData.data : []}
        />
      )}

      {openModalDeleteFooterSetting && (
        <ModalDeleteFooterSetting
          open={openModalDeleteFooterSetting}
          toggle={() => setOpenModalDeleteFooterSetting(false)}
          openEdit={() => setOpenModalCreateIFooterSetting(true)}
          data={footerstingEditData}
        />
      )}
    </>
  );
};

export default AdminFooterSetting;
